<template>
  <div style="padding-left: 10px">
    <el-tabs v-model="tabName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="保卡/机箱" name="tag">
        <el-form :model="formData" label-width="100px" ref="tagForm">
          <el-form-item label="CITEM：" required  prop="citem">
            <el-input v-model="formData.citem" style="width: 240px"  placeholder="每批订单变更一次"/>
          </el-form-item>

          <el-form-item label="制造日期：" required prop="produce_date">
            <el-input v-model="formData.produce_date" style="width: 240px"  placeholder="每批订单变更一次" />
          </el-form-item>

          <el-form-item label="36M：" required prop="m36">
            <el-input v-model="formData.m36" style="width: 240px"  placeholder="每批订单变更一次" />
          </el-form-item>

          <el-form-item label="SN：" required  prop="sn">
            <el-input v-model="formData.sn" style="width: 240px"  placeholder="商品SN，每台变化" />
          </el-form-item>

          <el-form-item label="">
            <el-button :loading="loading" @click="postPrint('item','tag')">打印保卡/机箱标签</el-button>
            <KfMessage ref="commitMessage"></KfMessage>
          </el-form-item>

        </el-form>
        <img :src="imageBase64" class="preview-img" v-if="imageBase64.length > 0">
      </el-tab-pane>

      <el-tab-pane label="外箱" name="box" >
        <div>
          <el-container>
            <el-aside width="800px">
              <el-form  ref="boxForm" :inline="true" :model="formData" label-width="110px" style="width: 800px">
                <div v-if="formPage===1">
                  <el-form-item label="型号:" required prop="box_type">
                    <el-input v-model="formData.box_type" style="width: 230px"  placeholder="每批订单变更一次"/>
                  </el-form-item>

                  <el-form-item label="CITEM#:" required prop="citem">
                    <el-input v-model="formData.citem" style="width: 230px"  placeholder="每批订单变更一次"/>
                  </el-form-item>

                  <el-form-item label="SO#:" required prop="so">
                    <el-input v-model="formData.so" style="width: 230px"  placeholder="每批订单变更一次"/>
                  </el-form-item>

                  <el-form-item label="PN#:" required prop="pn">
                    <el-input v-model="formData.pn" style="width: 230px"  placeholder="每批订单变更一次"/>
                  </el-form-item>

                  <el-form-item label="微软SN码:" required prop="microsoft_key">
                    <el-input v-model="formData.microsoft_key" style="width: 230px"  placeholder="每台变更"/>
                  </el-form-item>

                  <el-form-item label="SN:" required prop="sn">
                    <el-input v-model="formData.sn" style="width: 230px"  placeholder="商品SN，每台变化" />
                  </el-form-item>

                  <el-form-item label="EAN:" required prop="ean">
                    <el-input v-model="formData.ean" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="EMS SO:" required prop="ems_so">
                    <el-input v-model="formData.ems_so" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="E89C:" required prop="e89c">
                    <el-input v-model="formData.e89c" style="width: 230px"  placeholder="每台变更" />
                  </el-form-item>

                  <el-form-item label="EMS PN:" required prop="ems_pn">
                    <el-input v-model="formData.ems_pn" style="width: 230px"  placeholder="每台变更" />
                  </el-form-item>

                  <el-form-item label="ID+COLOR:" required prop="color">
                    <el-input v-model="formData.color" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="CPU:" required prop="cpu">
                    <el-input v-model="formData.cpu" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="VGA:" required  prop="vga">
                    <el-input v-model="formData.vga" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="STORAGE:" required prop="storage">
                    <el-input v-model="formData.storage" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="ODD:" required prop="odd">
                    <el-input v-model="formData.odd" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="MEMORY:" required prop="memory">
                    <el-input v-model="formData.memory" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label=" ">
                    <el-button @click="formPageSwitch(1)">下一页</el-button>
                  </el-form-item>
                </div>
                <div v-if="formPage===2">
                  <el-form-item label="OS TYPE:" required prop="os_type">
                    <el-input v-model="formData.os_type" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="制造日期:" required prop="produce_date">
                    <el-input v-model="formData.produce_date" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="36M:" required  prop="m36">
                    <el-input v-model="formData.m36" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="产地:" required prop="origin">
                    <el-input v-model="formData.origin" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="制造商:" required prop="mfrs">
                    <el-input v-model="formData.mfrs" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="生产商:" required  prop="producer">
                    <el-input v-model="formData.producer" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="上海通讯地址:" required  prop="sh_address">
                    <el-input v-model="formData.sh_address" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="地址:" required  prop="address">
                    <el-input v-model="formData.address" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="执行标准编号:" required  prop="standard">
                    <el-input v-model="formData.standard" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label="电话:" required prop="phone">
                    <el-input v-model="formData.phone" style="width: 230px"  placeholder="每批订单变更一次" />
                  </el-form-item>

                  <el-form-item label=" ">
                    <el-button @click="formPageSwitch(0)">上一页</el-button>
                    <el-button :loading="loading" @click="postPrint('item','box')">打印外箱标签</el-button>
                    <el-button :loading="loading" @click="postPrint('item','box_two')">打印外箱标签2</el-button>
                    <KfMessage ref="commitMessage"></KfMessage>
                  </el-form-item>
                </div>

              </el-form>
            </el-aside>
            <el-main>
              <div class="demo-image__lazy" v-if="imageBase64.length > 0">
                <el-image :src="imageBase64" lazy />
              </div>
            </el-main>
          </el-container>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
<!--  <img :src="imageBase64" class="preview-img" v-if="imageBase64.length > 0">-->

</template>

<script>
import axios from 'axios'
import {reactive, ref} from "vue";

export default{
  name: "FormPrint",
  emits: ['submitted'],
  setup(){
    const boxForm = ref();
    const formData = reactive({
      type: '',
          name: '',
          citem: '',
          sn: '',
          box_no: '',
          template_id: '',
          box_type:'',
          so:'',
          pn:'',
          microsoft_key:'',
          ean:'',
          ems_so:'',
          e89c:'',
          color:'',
          cpu:'',
          vga:'',
          storage:'',
          odd:'',
          memory:'',
          os_type:'',
          origin:'',
          mfrs:'',
          producer:'',
          sh_address:'',
          address:'',
          standard:'',
          phone:'',
          ems_pn:''
    });
    const resetForm = () => {
      boxForm.value.resetFields();
    };
    return{
      resetForm,
      boxForm,
      formData
    }
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formPage:1,
      templates: [],
      formItems: [],
      bomList: [],
      imageBase64: '',
      imageHeight: 400,
      imageWidth: 600,
      printDto: {},
      tabName: 'tag',
      loading: false
    }
  },
  created() {
    this.loadTemplates()
  },
  methods:{
    loadTemplates() {
      console.log("loadTemplates in")
      this.$http('rebuildPrintService.getFormTemplates').then(data => {
        this.loading = false;
        this.templates = data || []
      }, errMsg => {
        this.$message.error(`获取打印模板失败，${errMsg}`);
      })
    },
    async postPrint(type, name) {
      this.$refs.commitMessage.clear();
      await this.postPreview(type, name);

      console.log(this.printDto)

      if (!this.imageBase64 || this.imageBase64.length == 0) {
        return;
      }

      this.loading = true;
      //调用本地打印服务器
      let printParams = {
        printer_name: this.printDto.printerName,
        image_base_64: this.printDto.imageBase64,
        request_id:'this.printDto.tempId'
      };
      axios.defaults.headers['Content-Type'] = 'multipart/form-data';
      axios.post("http://localhost:9000/print", printParams).then(response => {
        this.loading = false;
        let res = response.data;
        if (res.code === 1) {
          this.$refs.commitMessage.showError(res.data);
          return;
        }
        console.log(res)
        if (res.code === 1) {
          this.$refs.commitMessage.showError(res.data);
        }
      }, error => {
        console.log("print error")
        console.log(error)
        this.loading = false;
        this.$refs.commitMessage.showError(`提交打印失败,请检查打印小程序`);
      })
    },
    async postPreview(type, name) {
      if ("item" === type && this.formData.sn.length === 0) {
        this.$refs.commitMessage.showError('SN码不能为空')
        return;
      }

      if ("box" === type && this.formData.box_no.length === 0) {
        this.$refs.commitMessage.showError('请选择输入箱号')
        return;
      }

      if ("template" === type && this.formData.template_id.length === 0) {
        this.$refs.commitMessage.showError('请选择打印模板')
        return;
      }
      this.formData.type = type;
      this.formData.name = name;

      this.loading = true;
      // 这里加await等待调用完毕，否则postPrint会出问题
      await this.$http('rebuildPrintService.createPrintDto', this.formData,false).then(data => {
        this.loading = false;
        this.printDto = data;
        this.imageBase64 = data.imageBase64 || '';
        console.log("imageBase64=" + this.imageBase64);

        if (this.imageBase64.length > 0) {
          this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
        }
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },
    handleClick(){
      this.imageBase64 = '';
      this.resetForm();
    },
    formPageSwitch(item) {
      if (item === 1) {
        this.formPage++;
      } else if (item === 0) {
        this.formPage--
      }
    },
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 350px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.preview-img {
  position: absolute;
  top: 60px;
  right: 20px;
  border: 1px solid #e5e5e5;
  width: 800px;
  height: auto;
}

.demo-image__lazy {
  height: 500px;
  overflow-y: auto;
}
.demo-image__lazy .el-image {
  display: block;
  min-height: 200px;
  margin-bottom: 10px;
}
.demo-image__lazy .el-image:last-child {
  margin-bottom: 0;
}
</style>